module.exports = __webpack_public_path__ + "static/media/Picture-perfect-Web-In-villa-activities-04.5d7dbec3.webp";